var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.appClick}},[_c('router-view'),_c('portal-target',{attrs:{"name":"contextMenuFolder"}}),_c('portal-target',{attrs:{"name":"contextMenuWorkspace"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }